import logo from './logo.gif';
import './App.css';
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <img src={logo} alt="logo" className="App-logo img-fluid" />
        </header>
        <main>
          <Dictionary defaultKeyword="anime" />
        </main>
        <footer className='App-footer'>
          Coded by Patricia
        </footer>
      </div>
    </div>
  );
}

